// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__BGdNe","select":"Header_select__vUqWZ","clinic":"Header_clinic__1eDqx"};